import { QaQcData, QaQcDropDown } from "@gtpl/shared-models/production-management";
import { EntityRepository, Repository } from "typeorm";
import { OperationRequest } from "../operations/dto/operations.request";
import { QaQcOperations } from "./qa-qc-operations.entity";

@EntityRepository(QaQcOperations)
export class QaQcOperationsRepository extends Repository<QaQcOperations> {

    async getAllQcQcTests(): Promise<QaQcData[]> {
        try {
            const response: QaQcData[] = await this.createQueryBuilder('qa_qc_operations')
                .select('qa_qc_op_id as qaQcTestId, test_code as testCode, test_name as testName, qa_qc_operations.operation_id as operationInfo, qa_qc_operations.is_active as isActive, qa_qc_operations.created_user as createdUser, qa_qc_operations.updated_user as updatedUser, qa_qc_operations.created_at as createdAt, qa_qc_operations.updated_at as updatedAt, qa_qc_operations.version_flag as versionFlag, operationDetails.operation_name as operationName')
                .leftJoin('qa_qc_operations.operationInfo', 'operationDetails')
                .orderBy('operation_name, test_name')
                .getRawMany();

            return response;
        } catch (error) {
            return error;
        }
    }

    async getAllQcQcActiveTests(): Promise<QaQcData[]> {
        try {
            const response: QaQcData[] = await this.createQueryBuilder('qa_qc_operations')
                .select('qa_qc_op_id as qaQcTestId, test_code as testCode, test_name as testName, qa_qc_operations.operation_id as operationInfo, qa_qc_operations.is_active as isActive, qa_qc_operations.created_user as createdUser, qa_qc_operations.updated_user as updatedUser, qa_qc_operations.created_at as createdAt, qa_qc_operations.updated_at as updatedAt, qa_qc_operations.version_flag as versionFlag, operationDetails.operation_name as operationName')
                .leftJoin('qa_qc_operations.operationInfo', 'operationDetails')
                .where(`qa_qc_operations.is_active=true`)
                .orderBy('operation_name, test_name')
                .getRawMany();

            return response;
        } catch (error) {
            return error;
        }
    }


    async getAllQcQcTestsForOperation(req: OperationRequest): Promise<QaQcData[]> {
        try {
            const response: QaQcData[] = await this.createQueryBuilder('qa_qc_operations')
                .select('qa_qc_op_id as qaQcTestId, test_code as testCode, test_name as testName, qa_qc_operations.operation_id as operationInfo, qa_qc_operations.is_active as isActive, qa_qc_operations.created_user as createdUser, qa_qc_operations.updated_user as updatedUser, qa_qc_operations.created_at as createdAt, qa_qc_operations.updated_at as updatedAt, qa_qc_operations.version_flag as versionFlag, operationDetails.operation_name as operationName')
                .leftJoin('qa_qc_operations.operationInfo', 'operationDetails')
                .where(`qa_qc_operations.operation_id='${req.operationId}'`)
                .orderBy('operation_name, test_name')
                .getRawMany();

            return response;
        } catch (error) {
            return error;
        }
    }

    async getAllQcQcActiveTestsForOperation(req: OperationRequest): Promise<QaQcData[]> {
        try {
            const response: QaQcData[] = await this.createQueryBuilder('qa_qc_operations')
                .select('qa_qc_op_id as qaQcTestId, test_code as testCode, test_name as testName, qa_qc_operations.operation_id as operationInfo, qa_qc_operations.is_active as isActive, qa_qc_operations.created_user as createdUser, qa_qc_operations.updated_user as updatedUser, qa_qc_operations.created_at as createdAt, qa_qc_operations.updated_at as updatedAt, qa_qc_operations.version_flag as versionFlag, operationDetails.operation_name as operationName')
                .leftJoin('qa_qc_operations.operationInfo', 'operationDetails')
                .where(`qa_qc_operations.operation_id='${req.operationId}' and qa_qc_operations.is_active=true`)
                .orderBy('operation_name, test_name')
                .getRawMany();

            return response;
        } catch (error) {
            return error;
        }
    }

    async getAllQcQcDropDownForOperation(req: OperationRequest): Promise<QaQcDropDown[]> {
        try {
            const response: QaQcDropDown[] = await this.createQueryBuilder('qa_qc_operations')
                .select('qa_qc_op_id as qaQcTestId, test_name as testName')
                .leftJoin('qa_qc_operations.operationInfo', 'operationDetails')
                .where(`operationDetails.operation_name= "${req.operationName}" and qa_qc_operations.is_active=true`)
                .orderBy('test_name')
                .getRawMany();

            return response;
        } catch (error) {
            return error;
        }
    }
}
